<mat-card class="visualization chart">
  <mat-card-header>
    <mat-card-title><h1>Section Radar - {{assessment?.assessmentName}}</h1></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <canvas baseChart
    [datasets]="radarChartData"
    [labels]="radarChartLabels"
    [chartType]="radarChartType"
    [options]="chartOptions"
    [legend]="false"
    (chartHover)="chartHovered($event)"
    (chartClick)="chartClicked($event)"></canvas>
  </mat-card-content>
</mat-card>